import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  template      : ``,
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in
 *    IE on Windows Phone and in iOS.
 */
html {
  line-height: 1.15;
  /* 1 */
  -ms-text-size-adjust: 100%;
  /* 2 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
}
/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers (opinionated).
 */
body {
  margin: 0;
}
/**
 * Add the correct display in IE 9-.
 */
article,
aside,
footer,
header,
nav,
section {
  display: block;
}
/**
 * Correct the font size and margin on 'h1' elements within 'section' and
 * 'article' contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
/* Grouping content
   ========================================================================== */
/**
 * Add the correct display in IE 9-.
 * 1. Add the correct display in IE.
 */
figcaption,
figure,
main {
  /* 1 */
  display: block;
}
/**
 * Add the correct margin in IE 8.
 */
figure {
  margin: 1em 40px;
}
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box;
  /* 1 */
  height: 0;
  /* 1 */
  overflow: visible;
  /* 2 */
}
/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd 'em' font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace;
  /* 1 */
  /* stylelint-disable-line */
  font-size: 1em;
  /* 2 */
}
/* Text-level semantics
   ========================================================================== */
/**
 * 1. Remove the gray background on active links in IE 10.
 * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
 */
a {
  background-color: transparent;
  /* 1 */
  -webkit-text-decoration-skip: objects;
  /* 2 */
}
/**
 * 1. Remove the bottom border in Chrome 57- and Firefox 39-.
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none;
  /* 1 */
  text-decoration: underline;
  /* 2 */
  text-decoration: underline dotted;
  /* 2 */
}
/**
 * Prevent the duplicate application of 'bolder' by the next rule in Safari 6.
 */
b,
strong {
  font-weight: inherit;
}
/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}
/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd 'em' font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace;
  /* 1 */
  /* stylelint-disable-line */
  font-size: 1em;
  /* 2 */
}
/**
 * Add the correct font style in Android 4.3-.
 */
dfn {
  font-style: italic;
}
/**
 * Add the correct background and color in IE 9-.
 */
mark {
  background-color: #ff0;
  color: #000;
}
/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}
/**
 * Prevent 'sub' and 'sup' elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/* Embedded content
   ========================================================================== */
/**
 * Add the correct display in IE 9-.
 */
audio,
video {
  display: inline-block;
}
/**
 * Add the correct display in iOS 4-7.
 */
audio:not([controls]) {
  display: none;
  height: 0;
}
/**
 * Remove the border on images inside links in IE 10-.
 */
img {
  border-style: none;
}
/**
 * Hide the overflow in IE.
 */
svg:not(:root) {
  overflow: hidden;
}
/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers (opinionated).
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: sans-serif;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: 1.15;
  /* 1 */
  margin: 0;
  /* 2 */
}
/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input {
  /* 1 */
  overflow: visible;
}
/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select {
  /* 1 */
  text-transform: none;
}
/**
 * 1. Prevent a WebKit bug where (2) destroys native 'audio' and 'video'
 *    controls in Android 4.
 * 2. Correct the inability to style clickable types in iOS and Safari.
 */
button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
  /* 2 */
}
/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}
/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}
/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from 'fieldset' elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    'fieldset' elements in all browsers.
 */
legend {
  box-sizing: border-box;
  /* 1 */
  color: inherit;
  /* 2 */
  display: table;
  /* 1 */
  max-width: 100%;
  /* 1 */
  padding: 0;
  /* 3 */
  white-space: normal;
  /* 1 */
}
/**
 * 1. Add the correct display in IE 9-.
 * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  display: inline-block;
  /* 1 */
  vertical-align: baseline;
  /* 2 */
}
/**
 * Remove the default vertical scrollbar in IE.
 */
textarea {
  overflow: auto;
}
/**
 * 1. Add the correct box sizing in IE 10-.
 * 2. Remove the padding in IE 10-.
 */
[type="checkbox"],
[type="radio"] {
  box-sizing: border-box;
  /* 1 */
  padding: 0;
  /* 2 */
}
/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type="search"] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}
/**
 * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
 */
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to 'inherit' in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}
/* Interactive
   ========================================================================== */
/*
 * Add the correct display in IE 9-.
 * 1. Add the correct display in Edge, IE, and Firefox.
 */
details,
menu {
  display: block;
}
/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}
/* Scripting
   ========================================================================== */
/**
 * Add the correct display in IE 9-.
 */
canvas {
  display: inline-block;
}
/**
 * Add the correct display in IE.
 */
template {
  display: none;
}
/* Hidden
   ========================================================================== */
/**
 * Add the correct display in IE 10-.
 */
[hidden] {
  display: none;
}
@font-face {
  font-family: "Helvetica Neue For Number";
  src: local("Helvetica Neue");
  unicode-range: U+30-39;
}
* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
*:before,
*:after {
  box-sizing: border-box;
}
html,
body {
  width: 100%;
  height: 100%;
}
body {
  font-family: "Helvetica Neue For Number", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
textarea,
p,
blockquote,
th,
td,
hr,
button,
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  margin: 0;
  padding: 0;
}
button,
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}
input[type="text"],
textarea {
  -webkit-appearance: none;
}
ul,
ol {
  list-style: none;
}
input::-ms-clear,
input::-ms-reveal {
  display: none;
}
::selection {
  background: #108ee9;
  color: #fff;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}
a {
  color: #108ee9;
  background: transparent;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color .3s ease;
}
a:focus {
  text-decoration: underline;
  text-decoration-skip: ink;
}
a:hover {
  color: #49a9ee;
}
a:active {
  color: #0e77ca;
}
a:active,
a:hover {
  outline: 0;
  text-decoration: none;
}
a[disabled] {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  pointer-events: none;
}
.ant-divider {
  margin: 0 6px;
  display: inline-block;
  height: 8px;
  width: 1px;
  background: #ccc;
}
code,
kbd,
pre,
samp {
  font-family: Consolas, Menlo, Courier, monospace;
}
.clearfix {
  zoom: 1;
}
.clearfix:before,
.clearfix:after {
  content: " ";
  display: table;
}
.clearfix:after {
  clear: both;
  visibility: hidden;
  font-size: 0;
  height: 0;
}
@font-face {
  font-family: 'anticon';
  src: url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.eot');
  /* IE9*/
  src: url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.eot?#iefix') format('embedded-opentype'), /* chrome、firefox */ url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.woff') format('woff'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/ url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.ttf') format('truetype'), /* iOS 4.1- */ url('https://at.alicdn.com/t/font_zck90zmlh7hf47vi.svg#iconfont') format('svg');
}
.anticon {
  display: inline-block;
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.anticon:before {
  display: block;
  font-family: "anticon" !important;
}
.anticon-step-forward:before {
  content: "\\e600";
}
.anticon-step-backward:before {
  content: "\\e601";
}
.anticon-forward:before {
  content: "\\e602";
}
.anticon-backward:before {
  content: "\\e603";
}
.anticon-caret-right:before {
  content: "\\e604";
}
.anticon-caret-left:before {
  content: "\\e605";
}
.anticon-caret-down:before {
  content: "\\e606";
}
.anticon-caret-up:before {
  content: "\\e607";
}
.anticon-right-circle:before {
  content: "\\e608";
}
.anticon-circle-right:before {
  content: "\\e608";
}
.anticon-caret-circle-right:before {
  content: "\\e608";
}
.anticon-left-circle:before {
  content: "\\e609";
}
.anticon-circle-left:before {
  content: "\\e609";
}
.anticon-caret-circle-left:before {
  content: "\\e609";
}
.anticon-up-circle:before {
  content: "\\e60a";
}
.anticon-circle-up:before {
  content: "\\e60a";
}
.anticon-caret-circle-up:before {
  content: "\\e60a";
}
.anticon-down-circle:before {
  content: "\\e60b";
}
.anticon-circle-down:before {
  content: "\\e60b";
}
.anticon-caret-circle-down:before {
  content: "\\e60b";
}
.anticon-right-circle-o:before {
  content: "\\e60c";
}
.anticon-circle-o-right:before {
  content: "\\e60c";
}
.anticon-caret-circle-o-right:before {
  content: "\\e60c";
}
.anticon-left-circle-o:before {
  content: "\\e60d";
}
.anticon-circle-o-left:before {
  content: "\\e60d";
}
.anticon-caret-circle-o-left:before {
  content: "\\e60d";
}
.anticon-up-circle-o:before {
  content: "\\e60e";
}
.anticon-circle-o-up:before {
  content: "\\e60e";
}
.anticon-caret-circle-o-up:before {
  content: "\\e60e";
}
.anticon-down-circle-o:before {
  content: "\\e60f";
}
.anticon-circle-o-down:before {
  content: "\\e60f";
}
.anticon-caret-circle-o-down:before {
  content: "\\e60f";
}
.anticon-verticle-left:before {
  content: "\\e610";
}
.anticon-verticle-right:before {
  content: "\\e611";
}
.anticon-rollback:before {
  content: "\\e612";
}
.anticon-retweet:before {
  content: "\\e613";
}
.anticon-shrink:before {
  content: "\\e614";
}
.anticon-arrows-alt:before {
  content: "\\e615";
}
.anticon-arrow-salt:before {
  content: "\\e615";
}
.anticon-reload:before {
  content: "\\e616";
}
.anticon-double-right:before {
  content: "\\e617";
}
.anticon-double-left:before {
  content: "\\e618";
}
.anticon-arrow-down:before {
  content: "\\e619";
}
.anticon-arrow-up:before {
  content: "\\e61a";
}
.anticon-arrow-right:before {
  content: "\\e61b";
}
.anticon-arrow-left:before {
  content: "\\e61c";
}
.anticon-down:before {
  content: "\\e61d";
}
.anticon-up:before {
  content: "\\e61e";
}
.anticon-right:before {
  content: "\\e61f";
}
.anticon-left:before {
  content: "\\e620";
}
.anticon-minus-square-o:before {
  content: "\\e621";
}
.anticon-minus-circle:before {
  content: "\\e622";
}
.anticon-minus-circle-o:before {
  content: "\\e623";
}
.anticon-minus:before {
  content: "\\e624";
}
.anticon-plus-circle-o:before {
  content: "\\e625";
}
.anticon-plus-circle:before {
  content: "\\e626";
}
.anticon-plus:before {
  content: "\\e627";
}
.anticon-info-circle:before {
  content: "\\e628";
}
.anticon-info-circle-o:before {
  content: "\\e629";
}
.anticon-info:before {
  content: "\\e62a";
}
.anticon-exclamation:before {
  content: "\\e62b";
}
.anticon-exclamation-circle:before {
  content: "\\e62c";
}
.anticon-exclamation-circle-o:before {
  content: "\\e62d";
}
.anticon-close-circle:before {
  content: "\\e62e";
}
.anticon-cross-circle:before {
  content: "\\e62e";
}
.anticon-close-circle-o:before {
  content: "\\e62f";
}
.anticon-cross-circle-o:before {
  content: "\\e62f";
}
.anticon-check-circle:before {
  content: "\\e630";
}
.anticon-check-circle-o:before {
  content: "\\e631";
}
.anticon-check:before {
  content: "\\e632";
}
.anticon-close:before {
  content: "\\e633";
}
.anticon-cross:before {
  content: "\\e633";
}
.anticon-customer-service:before {
  content: "\\e634";
}
.anticon-customerservice:before {
  content: "\\e634";
}
.anticon-credit-card:before {
  content: "\\e635";
}
.anticon-code-o:before {
  content: "\\e636";
}
.anticon-book:before {
  content: "\\e637";
}
.anticon-bar-chart:before {
  content: "\\e638";
}
.anticon-bars:before {
  content: "\\e639";
}
.anticon-question:before {
  content: "\\e63a";
}
.anticon-question-circle:before {
  content: "\\e63b";
}
.anticon-question-circle-o:before {
  content: "\\e63c";
}
.anticon-pause:before {
  content: "\\e63d";
}
.anticon-pause-circle:before {
  content: "\\e63e";
}
.anticon-pause-circle-o:before {
  content: "\\e63f";
}
.anticon-clock-circle:before {
  content: "\\e640";
}
.anticon-clock-circle-o:before {
  content: "\\e641";
}
.anticon-swap:before {
  content: "\\e642";
}
.anticon-swap-left:before {
  content: "\\e643";
}
.anticon-swap-right:before {
  content: "\\e644";
}
.anticon-plus-square-o:before {
  content: "\\e645";
}
.anticon-frown:before {
  content: "\\e646";
}
.anticon-frown-circle:before {
  content: "\\e646";
}
.anticon-ellipsis:before {
  content: "\\e647";
}
.anticon-copy:before {
  content: "\\e648";
}
.anticon-menu-fold:before {
  content: "\\e658";
}
.anticon-mail:before {
  content: "\\e659";
}
.anticon-logout:before {
  content: "\\e65a";
}
.anticon-link:before {
  content: "\\e65b";
}
.anticon-area-chart:before {
  content: "\\e65c";
}
.anticon-line-chart:before {
  content: "\\e65d";
}
.anticon-home:before {
  content: "\\e65e";
}
.anticon-laptop:before {
  content: "\\e65f";
}
.anticon-star:before {
  content: "\\e660";
}
.anticon-star-o:before {
  content: "\\e661";
}
.anticon-folder:before {
  content: "\\e662";
}
.anticon-filter:before {
  content: "\\e663";
}
.anticon-file:before {
  content: "\\e664";
}
.anticon-exception:before {
  content: "\\e665";
}
.anticon-meh:before {
  content: "\\e666";
}
.anticon-meh-circle:before {
  content: "\\e666";
}
.anticon-meh-o:before {
  content: "\\e667";
}
.anticon-shopping-cart:before {
  content: "\\e668";
}
.anticon-save:before {
  content: "\\e669";
}
.anticon-user:before {
  content: "\\e66a";
}
.anticon-video-camera:before {
  content: "\\e66b";
}
.anticon-to-top:before {
  content: "\\e66c";
}
.anticon-team:before {
  content: "\\e66d";
}
.anticon-tablet:before {
  content: "\\e66e";
}
.anticon-solution:before {
  content: "\\e66f";
}
.anticon-search:before {
  content: "\\e670";
}
.anticon-share-alt:before {
  content: "\\e671";
}
.anticon-setting:before {
  content: "\\e672";
}
.anticon-poweroff:before {
  content: "\\e6d5";
}
.anticon-picture:before {
  content: "\\e674";
}
.anticon-phone:before {
  content: "\\e675";
}
.anticon-paper-clip:before {
  content: "\\e676";
}
.anticon-notification:before {
  content: "\\e677";
}
.anticon-mobile:before {
  content: "\\e678";
}
.anticon-menu-unfold:before {
  content: "\\e679";
}
.anticon-inbox:before {
  content: "\\e67a";
}
.anticon-lock:before {
  content: "\\e67b";
}
.anticon-qrcode:before {
  content: "\\e67c";
}
.anticon-play-circle:before {
  content: "\\e6d0";
}
.anticon-play-circle-o:before {
  content: "\\e6d1";
}
.anticon-tag:before {
  content: "\\e6d2";
}
.anticon-tag-o:before {
  content: "\\e6d3";
}
.anticon-tags:before {
  content: "\\e67d";
}
.anticon-tags-o:before {
  content: "\\e67e";
}
.anticon-cloud-o:before {
  content: "\\e67f";
}
.anticon-cloud:before {
  content: "\\e680";
}
.anticon-cloud-upload:before {
  content: "\\e681";
}
.anticon-cloud-download:before {
  content: "\\e682";
}
.anticon-cloud-download-o:before {
  content: "\\e683";
}
.anticon-cloud-upload-o:before {
  content: "\\e684";
}
.anticon-environment:before {
  content: "\\e685";
}
.anticon-environment-o:before {
  content: "\\e686";
}
.anticon-eye:before {
  content: "\\e687";
}
.anticon-eye-o:before {
  content: "\\e688";
}
.anticon-camera:before {
  content: "\\e689";
}
.anticon-camera-o:before {
  content: "\\e68a";
}
.anticon-windows:before {
  content: "\\e68b";
}
.anticon-apple:before {
  content: "\\e68c";
}
.anticon-apple-o:before {
  content: "\\e6d4";
}
.anticon-android:before {
  content: "\\e938";
}
.anticon-android-o:before {
  content: "\\e68d";
}
.anticon-aliwangwang:before {
  content: "\\e68e";
}
.anticon-aliwangwang-o:before {
  content: "\\e68f";
}
.anticon-export:before {
  content: "\\e691";
}
.anticon-edit:before {
  content: "\\e692";
}
.anticon-circle-down-o:before {
  content: "\\e693";
}
.anticon-circle-down-:before {
  content: "\\e694";
}
.anticon-appstore-o:before {
  content: "\\e695";
}
.anticon-appstore:before {
  content: "\\e696";
}
.anticon-scan:before {
  content: "\\e697";
}
.anticon-file-text:before {
  content: "\\e698";
}
.anticon-folder-open:before {
  content: "\\e699";
}
.anticon-hdd:before {
  content: "\\e69a";
}
.anticon-ie:before {
  content: "\\e69b";
}
.anticon-file-jpg:before {
  content: "\\e69c";
}
.anticon-like:before {
  content: "\\e64c";
}
.anticon-like-o:before {
  content: "\\e69d";
}
.anticon-dislike:before {
  content: "\\e64b";
}
.anticon-dislike-o:before {
  content: "\\e69e";
}
.anticon-delete:before {
  content: "\\e69f";
}
.anticon-enter:before {
  content: "\\e6a0";
}
.anticon-pushpin-o:before {
  content: "\\e6a1";
}
.anticon-pushpin:before {
  content: "\\e6a2";
}
.anticon-heart:before {
  content: "\\e6a3";
}
.anticon-heart-o:before {
  content: "\\e6a4";
}
.anticon-pay-circle:before {
  content: "\\e6a5";
}
.anticon-pay-circle-o:before {
  content: "\\e6a6";
}
.anticon-smile:before {
  content: "\\e6a7";
}
.anticon-smile-circle:before {
  content: "\\e6a7";
}
.anticon-smile-o:before {
  content: "\\e6a8";
}
.anticon-frown-o:before {
  content: "\\e6a9";
}
.anticon-calculator:before {
  content: "\\e6aa";
}
.anticon-message:before {
  content: "\\e6ab";
}
.anticon-chrome:before {
  content: "\\e6ac";
}
.anticon-github:before {
  content: "\\e6ad";
}
.anticon-file-unknown:before {
  content: "\\e6af";
}
.anticon-file-excel:before {
  content: "\\e6b0";
}
.anticon-file-ppt:before {
  content: "\\e6b1";
}
.anticon-file-word:before {
  content: "\\e6b2";
}
.anticon-file-pdf:before {
  content: "\\e6b3";
}
.anticon-desktop:before {
  content: "\\e6b4";
}
.anticon-upload:before {
  content: "\\e6b6";
}
.anticon-download:before {
  content: "\\e6b7";
}
.anticon-pie-chart:before {
  content: "\\e6b8";
}
.anticon-unlock:before {
  content: "\\e6ba";
}
.anticon-calendar:before {
  content: "\\e6bb";
}
.anticon-windows-o:before {
  content: "\\e6bc";
}
.anticon-dot-chart:before {
  content: "\\e6bd";
}
.anticon-bar-chart:before {
  content: "\\e6be";
}
.anticon-code:before {
  content: "\\e6bf";
}
.anticon-api:before {
  content: "\\e951";
}
.anticon-plus-square:before {
  content: "\\e6c0";
}
.anticon-minus-square:before {
  content: "\\e6c1";
}
.anticon-close-square:before {
  content: "\\e6c2";
}
.anticon-close-square-o:before {
  content: "\\e6c3";
}
.anticon-check-square:before {
  content: "\\e6c4";
}
.anticon-check-square-o:before {
  content: "\\e6c5";
}
.anticon-fast-backward:before {
  content: "\\e6c6";
}
.anticon-fast-forward:before {
  content: "\\e6c7";
}
.anticon-up-square:before {
  content: "\\e6c8";
}
.anticon-down-square:before {
  content: "\\e6c9";
}
.anticon-left-square:before {
  content: "\\e6ca";
}
.anticon-right-square:before {
  content: "\\e6cb";
}
.anticon-right-square-o:before {
  content: "\\e6cc";
}
.anticon-left-square-o:before {
  content: "\\e6cd";
}
.anticon-down-square-o:before {
  content: "\\e6ce";
}
.anticon-up-square-o:before {
  content: "\\e6cf";
}
.anticon-loading:before {
  content: "\\e64d";
}
.anticon-loading-3-quarters:before {
  content: "\\e6ae";
}
.anticon-bulb:before {
  content: "\\e649";
}
.anticon-select:before {
  content: "\\e64a";
}
.anticon-addfile:before,
.anticon-file-add:before {
  content: "\\e910";
}
.anticon-addfolder:before,
.anticon-folder-add:before {
  content: "\\e914";
}
.anticon-switcher:before {
  content: "\\e913";
}
.anticon-rocket:before {
  content: "\\e90f";
}
.anticon-dingding:before {
  content: "\\e923";
}
.anticon-dingding-o:before {
  content: "\\e925";
}
.anticon-bell:before {
  content: "\\e64e";
}
.anticon-disconnect:before {
  content: "\\e64f";
}
.anticon-database:before {
  content: "\\e650";
}
.anticon-compass:before {
  content: "\\e6db";
}
.anticon-barcode:before {
  content: "\\e652";
}
.anticon-hourglass:before {
  content: "\\e653";
}
.anticon-key:before {
  content: "\\e654";
}
.anticon-flag:before {
  content: "\\e655";
}
.anticon-layout:before {
  content: "\\e656";
}
.anticon-login:before {
  content: "\\e657";
}
.anticon-printer:before {
  content: "\\e673";
}
.anticon-sound:before {
  content: "\\e6e9";
}
.anticon-usb:before {
  content: "\\e6d7";
}
.anticon-skin:before {
  content: "\\e6d8";
}
.anticon-tool:before {
  content: "\\e6d9";
}
.anticon-sync:before {
  content: "\\e6da";
}
.anticon-wifi:before {
  content: "\\e6d6";
}
.anticon-car:before {
  content: "\\e6dc";
}
.anticon-copyright:before {
  content: "\\e6de";
}
.anticon-schedule:before {
  content: "\\e6df";
}
.anticon-user-add:before {
  content: "\\e6ed";
}
.anticon-user-delete:before {
  content: "\\e6e0";
}
.anticon-usergroup-add:before {
  content: "\\e6dd";
}
.anticon-usergroup-delete:before {
  content: "\\e6e1";
}
.anticon-man:before {
  content: "\\e6e2";
}
.anticon-woman:before {
  content: "\\e6ec";
}
.anticon-shop:before {
  content: "\\e6e3";
}
.anticon-gift:before {
  content: "\\e6e4";
}
.anticon-idcard:before {
  content: "\\e6e5";
}
.anticon-medicine-box:before {
  content: "\\e6e6";
}
.anticon-red-envelope:before {
  content: "\\e6e7";
}
.anticon-coffee:before {
  content: "\\e6e8";
}
.anticon-trademark:before {
  content: "\\e651";
}
.anticon-safety:before {
  content: "\\e6ea";
}
.anticon-wallet:before {
  content: "\\e6eb";
}
.anticon-bank:before {
  content: "\\e6ee";
}
.anticon-trophy:before {
  content: "\\e6ef";
}
.anticon-contacts:before {
  content: "\\e6f0";
}
.anticon-global:before {
  content: "\\e6f1";
}
.anticon-shake:before {
  content: "\\e94f";
}
.anticon-fork:before {
  content: "\\e6f2";
}
.anticon-spin:before {
  display: inline-block;
  animation: loadingCircle 1s infinite linear;
}
.fade-enter,
.fade-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.fade-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.fade-enter.fade-enter-active,
.fade-appear.fade-appear-active {
  animation-name: antFadeIn;
  animation-play-state: running;
}
.fade-leave.fade-leave-active {
  animation-name: antFadeOut;
  animation-play-state: running;
  pointer-events: none;
}
.fade-enter,
.fade-appear {
  opacity: 0;
  animation-timing-function: linear;
}
.fade-leave {
  animation-timing-function: linear;
}
@keyframes antFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes antFadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.move-up-enter,
.move-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-up-enter.move-up-enter-active,
.move-up-appear.move-up-appear-active {
  animation-name: antMoveUpIn;
  animation-play-state: running;
}
.move-up-leave.move-up-leave-active {
  animation-name: antMoveUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.move-up-enter,
.move-up-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.move-up-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.move-down-enter,
.move-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-down-enter.move-down-enter-active,
.move-down-appear.move-down-appear-active {
  animation-name: antMoveDownIn;
  animation-play-state: running;
}
.move-down-leave.move-down-leave-active {
  animation-name: antMoveDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.move-down-enter,
.move-down-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.move-down-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.move-left-enter,
.move-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-left-enter.move-left-enter-active,
.move-left-appear.move-left-appear-active {
  animation-name: antMoveLeftIn;
  animation-play-state: running;
}
.move-left-leave.move-left-leave-active {
  animation-name: antMoveLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.move-left-enter,
.move-left-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.move-left-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
.move-right-enter,
.move-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.move-right-enter.move-right-enter-active,
.move-right-appear.move-right-appear-active {
  animation-name: antMoveRightIn;
  animation-play-state: running;
}
.move-right-leave.move-right-leave-active {
  animation-name: antMoveRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.move-right-enter,
.move-right-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.move-right-leave {
  animation-timing-function: cubic-bezier(0.6, 0.04, 0.98, 0.34);
}
@keyframes antMoveDownIn {
  0% {
    transform-origin: 0 0;
    transform: translateY(100%);
    opacity: 0;
  }
  100% {
    transform-origin: 0 0;
    transform: translateY(0%);
    opacity: 1;
  }
}
@keyframes antMoveDownOut {
  0% {
    transform-origin: 0 0;
    transform: translateY(0%);
    opacity: 1;
  }
  100% {
    transform-origin: 0 0;
    transform: translateY(100%);
    opacity: 0;
  }
}
@keyframes antMoveLeftIn {
  0% {
    transform-origin: 0 0;
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform-origin: 0 0;
    transform: translateX(0%);
    opacity: 1;
  }
}
@keyframes antMoveLeftOut {
  0% {
    transform-origin: 0 0;
    transform: translateX(0%);
    opacity: 1;
  }
  100% {
    transform-origin: 0 0;
    transform: translateX(-100%);
    opacity: 0;
  }
}
@keyframes antMoveRightIn {
  0% {
    opacity: 0;
    transform-origin: 0 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform-origin: 0 0;
    transform: translateX(0%);
  }
}
@keyframes antMoveRightOut {
  0% {
    transform-origin: 0 0;
    transform: translateX(0%);
    opacity: 1;
  }
  100% {
    transform-origin: 0 0;
    transform: translateX(100%);
    opacity: 0;
  }
}
@keyframes antMoveUpIn {
  0% {
    transform-origin: 0 0;
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform-origin: 0 0;
    transform: translateY(0%);
    opacity: 1;
  }
}
@keyframes antMoveUpOut {
  0% {
    transform-origin: 0 0;
    transform: translateY(0%);
    opacity: 1;
  }
  100% {
    transform-origin: 0 0;
    transform: translateY(-100%);
    opacity: 0;
  }
}
@keyframes loadingCircle {
  0% {
    transform-origin: 50% 50%;
    transform: rotate(0deg);
  }
  100% {
    transform-origin: 50% 50%;
    transform: rotate(360deg);
  }
}
.slide-up-enter,
.slide-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-up-enter.slide-up-enter-active,
.slide-up-appear.slide-up-appear-active {
  animation-name: antSlideUpIn;
  animation-play-state: running;
}
.slide-up-leave.slide-up-leave-active {
  animation-name: antSlideUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.slide-up-enter,
.slide-up-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-up-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.slide-down-enter,
.slide-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-down-enter.slide-down-enter-active,
.slide-down-appear.slide-down-appear-active {
  animation-name: antSlideDownIn;
  animation-play-state: running;
}
.slide-down-leave.slide-down-leave-active {
  animation-name: antSlideDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.slide-down-enter,
.slide-down-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.slide-left-enter,
.slide-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-left-enter.slide-left-enter-active,
.slide-left-appear.slide-left-appear-active {
  animation-name: antSlideLeftIn;
  animation-play-state: running;
}
.slide-left-leave.slide-left-leave-active {
  animation-name: antSlideLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.slide-left-enter,
.slide-left-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-left-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
.slide-right-enter,
.slide-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.slide-right-enter.slide-right-enter-active,
.slide-right-appear.slide-right-appear-active {
  animation-name: antSlideRightIn;
  animation-play-state: running;
}
.slide-right-leave.slide-right-leave-active {
  animation-name: antSlideRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.slide-right-enter,
.slide-right-appear {
  opacity: 0;
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}
.slide-right-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}
@keyframes antSlideUpIn {
  0% {
    opacity: 0;
    transform-origin: 0% 0%;
    transform: scaleY(0.8);
  }
  100% {
    opacity: 1;
    transform-origin: 0% 0%;
    transform: scaleY(1);
  }
}
@keyframes antSlideUpOut {
  0% {
    opacity: 1;
    transform-origin: 0% 0%;
    transform: scaleY(1);
  }
  100% {
    opacity: 0;
    transform-origin: 0% 0%;
    transform: scaleY(0.8);
  }
}
@keyframes antSlideDownIn {
  0% {
    opacity: 0;
    transform-origin: 100% 100%;
    transform: scaleY(0.8);
  }
  100% {
    opacity: 1;
    transform-origin: 100% 100%;
    transform: scaleY(1);
  }
}
@keyframes antSlideDownOut {
  0% {
    opacity: 1;
    transform-origin: 100% 100%;
    transform: scaleY(1);
  }
  100% {
    opacity: 0;
    transform-origin: 100% 100%;
    transform: scaleY(0.8);
  }
}
@keyframes antSlideLeftIn {
  0% {
    opacity: 0;
    transform-origin: 0% 0%;
    transform: scaleX(0.8);
  }
  100% {
    opacity: 1;
    transform-origin: 0% 0%;
    transform: scaleX(1);
  }
}
@keyframes antSlideLeftOut {
  0% {
    opacity: 1;
    transform-origin: 0% 0%;
    transform: scaleX(1);
  }
  100% {
    opacity: 0;
    transform-origin: 0% 0%;
    transform: scaleX(0.8);
  }
}
@keyframes antSlideRightIn {
  0% {
    opacity: 0;
    transform-origin: 100% 0%;
    transform: scaleX(0.8);
  }
  100% {
    opacity: 1;
    transform-origin: 100% 0%;
    transform: scaleX(1);
  }
}
@keyframes antSlideRightOut {
  0% {
    opacity: 1;
    transform-origin: 100% 0%;
    transform: scaleX(1);
  }
  100% {
    opacity: 0;
    transform-origin: 100% 0%;
    transform: scaleX(0.8);
  }
}
.swing-enter,
.swing-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.swing-enter.swing-enter-active,
.swing-appear.swing-appear-active {
  animation-name: antSwingIn;
  animation-play-state: running;
}
@keyframes antSwingIn {
  0%,
  100% {
    transform: translateX(0);
  }
  20% {
    transform: translateX(-10px);
  }
  40% {
    transform: translateX(10px);
  }
  60% {
    transform: translateX(-5px);
  }
  80% {
    transform: translateX(5px);
  }
}
.zoom-enter,
.zoom-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-enter.zoom-enter-active,
.zoom-appear.zoom-appear-active {
  animation-name: antZoomIn;
  animation-play-state: running;
}
.zoom-leave.zoom-leave-active {
  animation-name: antZoomOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-enter,
.zoom-appear {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-big-enter,
.zoom-big-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-big-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-big-enter.zoom-big-enter-active,
.zoom-big-appear.zoom-big-appear-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}
.zoom-big-leave.zoom-big-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-big-enter,
.zoom-big-appear {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-big-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-big-fast-enter,
.zoom-big-fast-appear {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-big-fast-leave {
  animation-duration: 0.1s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-big-fast-enter.zoom-big-fast-enter-active,
.zoom-big-fast-appear.zoom-big-fast-appear-active {
  animation-name: antZoomBigIn;
  animation-play-state: running;
}
.zoom-big-fast-leave.zoom-big-fast-leave-active {
  animation-name: antZoomBigOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-big-fast-enter,
.zoom-big-fast-appear {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-big-fast-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-up-enter,
.zoom-up-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-up-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-up-enter.zoom-up-enter-active,
.zoom-up-appear.zoom-up-appear-active {
  animation-name: antZoomUpIn;
  animation-play-state: running;
}
.zoom-up-leave.zoom-up-leave-active {
  animation-name: antZoomUpOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-up-enter,
.zoom-up-appear {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-up-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-down-enter,
.zoom-down-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-down-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-down-enter.zoom-down-enter-active,
.zoom-down-appear.zoom-down-appear-active {
  animation-name: antZoomDownIn;
  animation-play-state: running;
}
.zoom-down-leave.zoom-down-leave-active {
  animation-name: antZoomDownOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-down-enter,
.zoom-down-appear {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-down-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-left-enter,
.zoom-left-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-left-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-left-enter.zoom-left-enter-active,
.zoom-left-appear.zoom-left-appear-active {
  animation-name: antZoomLeftIn;
  animation-play-state: running;
}
.zoom-left-leave.zoom-left-leave-active {
  animation-name: antZoomLeftOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-left-enter,
.zoom-left-appear {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-left-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
.zoom-right-enter,
.zoom-right-appear {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-right-leave {
  animation-duration: 0.2s;
  animation-fill-mode: both;
  animation-play-state: paused;
}
.zoom-right-enter.zoom-right-enter-active,
.zoom-right-appear.zoom-right-appear-active {
  animation-name: antZoomRightIn;
  animation-play-state: running;
}
.zoom-right-leave.zoom-right-leave-active {
  animation-name: antZoomRightOut;
  animation-play-state: running;
  pointer-events: none;
}
.zoom-right-enter,
.zoom-right-appear {
  transform: scale(0);
  animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
}
.zoom-right-leave {
  animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
}
@keyframes antZoomIn {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes antZoomOut {
  0% {
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.2);
  }
}
@keyframes antZoomBigIn {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes antZoomBigOut {
  0% {
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}
@keyframes antZoomUpIn {
  0% {
    opacity: 0;
    transform-origin: 50% 0%;
    transform: scale(0.8);
  }
  100% {
    transform-origin: 50% 0%;
    transform: scale(1);
  }
}
@keyframes antZoomUpOut {
  0% {
    transform-origin: 50% 0%;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 0%;
    transform: scale(0.8);
  }
}
@keyframes antZoomLeftIn {
  0% {
    opacity: 0;
    transform-origin: 0% 50%;
    transform: scale(0.8);
  }
  100% {
    transform-origin: 0% 50%;
    transform: scale(1);
  }
}
@keyframes antZoomLeftOut {
  0% {
    transform-origin: 0% 50%;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform-origin: 0% 50%;
    transform: scale(0.8);
  }
}
@keyframes antZoomRightIn {
  0% {
    opacity: 0;
    transform-origin: 100% 50%;
    transform: scale(0.8);
  }
  100% {
    transform-origin: 100% 50%;
    transform: scale(1);
  }
}
@keyframes antZoomRightOut {
  0% {
    transform-origin: 100% 50%;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform-origin: 100% 50%;
    transform: scale(0.8);
  }
}
@keyframes antZoomDownIn {
  0% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0.8);
  }
  100% {
    transform-origin: 50% 100%;
    transform: scale(1);
  }
}
@keyframes antZoomDownOut {
  0% {
    transform-origin: 50% 100%;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0.8);
  }
}
.ant-motion-collapse {
  overflow: hidden;
}
.ant-motion-collapse-active {
  transition: height 0.15s cubic-bezier(0.645, 0.045, 0.355, 1), opacity 0.15s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
}
`,
    `/**
 * Global styles for all components (WANT antd's global style? SEE at components/style)
 */
.cdk-overlay-container {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-backdrop {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
  position: absolute;
  pointer-events: auto;
  z-index: 1000;
}
.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  z-index: 1000;
}
`,
  ],
  encapsulation : ViewEncapsulation.None,
})
export class NzRootStyleComponent { }
